//tslint:disable:export-name
export { VtoService } from './service-setup/VtoService';
import { diContainer, serviceNames } from './service-setup/diContainer';
import { setupServiceInfo } from 'elc-universal-utils';

diContainer.get(serviceNames.vtoService).register();

setupServiceInfo(__serviceInfo__);
